
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import PreschoolDimensionsView from "./components/PreschoolDimensionsContent.vue";

export default defineComponent({
  name: "PreschoolDimensionsPage",
  components: {
    BreadCrumb,
    PreschoolDimensionsView,
  },
});
